import React from 'react';
import { Card, Select } from '@avila-tek/ui/src';
import { ACTIONS, ACTIONS_TYPE } from './employeeInfoReducer';
import { CompanyDetails, EmployeeInfo } from '../../../../models';
import FormHeader, { FormHeaderProps } from '../FormHeader';

interface EmployeeInfoFormProps {
  dispatch?: React.Dispatch<ACTIONS_TYPE>;
  state?: Partial<EmployeeInfo>;
  header?: FormHeaderProps;
  disabled?: boolean;
  companyInfo: CompanyDetails;
}

function EmployeeInfoForm({
  header,
  state,
  dispatch = () => {},
  disabled = false,
  companyInfo,
}: EmployeeInfoFormProps) {
  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    dispatch({ type: name as any, payload: value });
  };

  return (
    <Card>
      <FormHeader
        href={header?.href ?? ''}
        backBtnText={header?.backBtnText ?? ''}
        title={header?.title ?? ''}
      />
      <Card.Body>
        <div className="w-full flex md:flex-row flex-col gap-5">
          <div className="w-full">
            <Select
              name={ACTIONS.ROLE}
              value={state.role ?? ''}
              label="Cargo"
              onChange={handleChangeSelect}
            >
              <option value="" disabled>
                Seleccione
              </option>
              {companyInfo?.structure?.map((role) => (
                <option key={role} value={role}>
                  {role}
                </option>
              ))}
            </Select>
          </div>
          <div className="w-full">
            <Select
              name={ACTIONS.RELATIONSHIP}
              value={state?.relationship ?? ''}
              label="Relación del beneficiario con la empresa"
              onChange={handleChangeSelect}
            >
              <option value="" disabled>
                Seleccione
              </option>
              <option value="direct">Directa</option>
              <option value="indirect">Indirecta</option>
            </Select>
          </div>
        </div>
        <div className="w-full flex md:flex-row flex-col gap-5">
          <div className="w-full">
            <Select
              name={ACTIONS.SALES_CHANNEL}
              value={state?.salesChannel ?? ''}
              label="Canal de ventas"
              onChange={handleChangeSelect}
            >
              <option value="" disabled>
                Seleccione
              </option>
              {companyInfo?.saleChannels.map((channel) => (
                <option key={channel} value={channel}>
                  {channel}
                </option>
              ))}
            </Select>
          </div>
          <div className="w-full">
            <Select
              name={ACTIONS.REGION}
              value={state?.region ?? ''}
              label="Región asiganda al beneficiario"
              onChange={handleChangeSelect}
            >
              <option value="" disabled>
                Seleccione
              </option>
              {companyInfo?.regions.map((region) => (
                <option key={region?.name} value={region?.name}>
                  {region?.name}
                </option>
              ))}
            </Select>
          </div>
        </div>
        <div className="w-full flex md:flex-row flex-col gap-5">
          <div className="w-full">
            <Select
              name={ACTIONS.SUBREGION}
              value={state?.subRegion ?? ''}
              label="Subregión asiganda al beneficiario"
              onChange={handleChangeSelect}
              disabled={!state?.region}
            >
              <option value="" disabled>
                Seleccione
              </option>
              {companyInfo?.regions
                .find((region) => region?.name === state?.region)
                ?.subRegions.map((subRegion) => (
                  <option key={subRegion} value={subRegion}>
                    {subRegion}
                  </option>
                )) ?? <option value="">Seleccione una región</option>}
            </Select>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default EmployeeInfoForm;
